<template>
  <div class="pc-wrapping">
    <!-- 头部 -->
    <div class="pc-header">
      <!-- logo -->
      <div class="pc-logo">
        <el-image :src="logoUrl"> </el-image>
      </div>
    </div>

    <!-- 底图 -->
    <div class="pc-main-image"></div>

    <!-- 内容 -->
    <div class="pc-content">
      <!-- home-内容 -->
      <div class="pc-content-home">
        <el-form :model="buyForm" :rules="rules" ref="buyForm" >
          <!-- 输入框 -->
          <div class="pc-uid-search">
            <div>
              <el-form-item prop="uid">
                <el-input
                  :placeholder="$t('recharge.index.uid_placeholder')"
                  v-model.number="buyForm.uid"
                  class="pc-uid-input-control"
                  maxlength="10"
                >
                  <template slot="prepend">{{ $t('recharge.index.uid') }}</template>
                </el-input>
              </el-form-item>
              <div class="pc-uid-search-subtitle">{{ $t('recharge.index.uid_notice') }}</div>
            </div>

            <div class="pc-uid-search-recaptcha" v-show="recaptchaVisible">
              <el-form-item prop="captcha">
                <vue-recaptcha
                  ref="recaptcha"
                  :sitekey="recaptchaConfig.sitekey"
                  :loadRecaptchaScript="true"
                  @verify="onVerify"
                  @expired="onExpired"
                >
                </vue-recaptcha>
              </el-form-item>
            </div>

            <div style="display: inline-block; margin-top: 10px;">
              <div class="el-alert el-alert--error is-center is-light" style="background-color: #11528a;">
                <i class="el-alert__icon el-icon-warning is-big" style="color: #248ed8;"></i>
                <div class="el-alert__content">
                  <p class="el-alert__description" style="color: #effaff;">{{ $t('recharge.index.contact_notice') }} </p>
                  <p><el-link type="primary" href="https://linktr.ee/XPoker" target="_blank" style="color: #3dddff;">https://linktr.ee/XPoker</el-link></p>
                  <i class="el-alert__closebtn el-icon-close" style="display: none;"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- 产品 -->
          <div class="pc-product-list">
            <div class="card-grid">
              <div v-for="(product, index) in productList" class="card-item" v-show="product.isShow" :key="index">
                <el-card
                  :body-style="{ padding: '0px', border: '0px' }"
                  :class=" productCheckIndex === index ? 'pc-product-item-check' : 'pc-product-item' "
                  @click.native="productCheck(index)"
                >
                  <div v-if="product.extra" class="pc-flag">
                    <span>{{ product.extra }}</span>
                  </div>
                  <div class="pc-product-item-num">
                    <div class="pc-product-item-num-group">
                      <el-image :src="diamondUrl"></el-image>
                      <span class="item-num">x</span>
                      <span class="item-num">{{ product.diamond }}</span>
                    </div>
                  </div>
                  <div class="pc-product-item-price">
                    <span>{{ product.price }}</span>
                  </div>
                </el-card>
              </div>
            </div>
          </div>

          <div>
            <!-- 按钮 -->
            <el-row>
              <el-button
                class="pc-confirm-btn"
                :disabled="submitBtnDisable"
                @click="submit"
                >{{ $t('recharge.common.btn_confirm') }}</el-button
              >
            </el-row>
          </div>

        </el-form>
      </div>
    </div>

    <!-- 底部 -->
    <div class="pc-footer">
      <div class="pc-footer-info">
        <x-foot/>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/home/pc/logo.png'
import marketing from '@/assets/images/home/pc/marketing.png'
import diamond from '@/assets/images/recharge/pc/product-item-diamond.png'
import { userInfo } from '@/api/user'
import productConfig from '@/util/product'
import VueRecaptcha from 'vue-recaptcha'
import reConfig from '@/config/common/captcha'
import foot from '@/views/components/foot'

export default {
  name: 'RechargeIndexPc',
  components: {
    'x-foot': foot,
    VueRecaptcha
  },
  data () {
    return {
      logoUrl: logo,
      diamondUrl: diamond,
      marketingUrl: marketing,
      recaptchaConfig: reConfig,
      recaptchaVisible: false,
      captcha: '',
      submitBtnDisable: false,
      buyForm: {
        uid: '',
        productId: ''
      },
      productCheckIndex: -1,
      rules: {
        uid: [
          { required: true, message: this.$t('recharge.index.uid_required_message'), trigger: 'blur' },
          { type: 'integer', message: this.$t('recharge.index.uid_message'), trigger: 'blur' }
        ]
      },
      productList: [],
      productInfo: {},
      productId: '',
      isTest: false
    }
  },
  mounted () {
    // google recaptcha 延迟show
    this.delayRecaptcha(true)

    this.productList = productConfig
    this.isTest = this.$route.query.hasOwnProperty('env') && this.$route.query.env === '5mcqhztk'
    if (this.isTest) {
      this.productList = [
        {
          isShow: true,
          productId: 'xpoker-diamond1',
          diamond: '1',
          price: '$1',
          extra: ''
        },
        {
          isShow: true,
          productId: 'xpoker-diamond3',
          diamond: '3',
          price: '$10',
          extra: ''
        },
        {
          isShow: true,
          productId: 'xpoker-diamond30',
          diamond: '30',
          price: '$30',
          extra: ''
        }
      ]
    }
  },
  methods: {
    delayRecaptcha (isShow) {
      let that = this
      setTimeout(function () {
        that.recaptchaVisible = isShow
      }, 400, that, isShow)
    },
    productCheck (index) {
      this.productCheckIndex = index
      this.buyForm.productId = this.productList[index].productId
      this.productInfo = this.productList[index]
      console.log(this.buyForm)
    },
    onVerify (response) {
      this.captcha = response
      console.log('onVerify', response)
      this.delayRecaptcha(false)
    },
    onExpired () {
      console.log('onExpired')

      this.delayRecaptcha(true)
    },
    resetRecaptcha () {
      this.captcha = ''
      this.$refs.recaptcha.reset() // Direct call reset method
    },
    submit () {
      if (!this.captcha) {
        this.$message({
          showClose: true,
          message: this.$t('recharge.common.re_captcha_message'),
          type: 'error'
        })

        this.submitBtnDisable = false
        return false
      }

      this.$refs['buyForm'].validate(valid => {
        if (valid) {
          this.submitBtnDisable = true
          if (!this.buyForm.productId) {
            this.$message({
              showClose: true,
              message: this.$t('recharge.common.check_produce_message'),
              type: 'error'
            })

            this.submitBtnDisable = false
            return false
          }

          userInfo({uid: this.buyForm.uid, captcha: this.captcha})
            .then(({ data }) => {
              if (data.uid) {
                let userInfos = JSON.parse(window.localStorage.getItem('userinfos')) || {}
                userInfos[data.uid] = data
                window.localStorage.setItem('userinfos', JSON.stringify(userInfos))
                this.$router.push({
                  name: 'Payment',
                  params: {
                    buyForm: this.buyForm,
                    productInfo: this.productInfo,
                    userInfo: data,
                    isTest: this.isTest
                  }
                })
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('recharge.common.user_not_found_message'),
                  type: 'error'
                })
              }
              this.submitBtnDisable = false
            })
            .catch(() => {
              this.$message({
                showClose: true,
                message: this.$t('recharge.common.server_err'),
                type: 'error'
              })
              this.submitBtnDisable = false
            })
        }
      })
    }
  }
}
</script>

<!-- 覆盖样式 -->
<style>
.pc-content{
      margin-bottom: 150px;
}

.pc-uid-input-control .el-input-group__prepend {
  background-color: #4079b9;
  color: #ffffff;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px; /* no*/
  padding: 0 10px; /* no*/
  border: none;
}
.el-form-item__error {
  text-align: center;
  right: 0;
}

.pc-product-list .el-row {
  margin-bottom: 20px; /* no*/
}

.pc-product-list .el-card {
  border: 0px;
  overflow: visible;
}
.pc-uid-search-recaptcha{
  margin-top: 10px;
}
.pc-uid-search-recaptcha div div {
  display: contents;
}
</style>

<style scoped>
.pc-wrapping {
  background: url("~@/assets/images/recharge/pc/backgourp_image.jpg") repeat-x;
  position: fixed;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  min-width: 1024px; /* no*/
  min-height: 100%; /* no*/
  overflow-x: hidden;
  overflow-y: auto;
} /* no*/

.pc-header {
  width: 300px; /* no*/
  display: -webkit-flex;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;

  margin-top: 50px;
} /* no*/

.pc-logo {
  width: 270px; /* no*/
  height: 70px; /* no*/
  -webkit-flex: 1;
  flex: 1;
} /* no*/

.pc-main-image {
  width: 46%;
  margin: 0 auto;
  z-index: -1;
} /* no*/

.pc-uid-input {
  border-radius: 3px; /* no*/
  position: relative;
  display: table;
  border-collapse: separate;
} /* no*/

.pc-uid-input-control {
  width: 420px;
} /* no*/

.pc-uid-search-subtitle {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px; /* no*/
  font-weight: normal;
  font-stretch: normal;
  line-height: 10px; /* no*/
  letter-spacing: 0px;
  color: #ffffff;
} /* no*/

.pc-product-list {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 100vh; */
} /* no*/

.pc-product-item {
  width: 247px; /* no*/
  height: 200px; /* no*/
  background: url("~@/assets/images/recharge/pc/product-item-up.png") center
    bottom no-repeat;
} /* no*/

.pc-product-item-check {
  width: 247px; /* no*/
  height: 200px; /* no*/
  background: url("~@/assets/images/recharge/pc/product-item-down.png") center
    bottom no-repeat;
} /* no*/

.pc-product-item-num {
  height: 146px; /* no*/
  position: relative;
}

.pc-product-item-num-group {
  position: absolute;
  width: 100%;
  height: 45px; /* no*/
  bottom: 0; /* no*/
}

.pc-product-item-num-group .item-num {
  top: 50%;
  transform: translate(0, -50%);
  text-align: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 22px; /* no*/
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #bfd9ff;
}

.pc-product-item-price {
  line-height: 50px; /* no*/
  margin-bottom: 1px; /* no*/
  font-family: SourceHanSansCN-Regular;
  font-size: 22px; /* no*/
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px; /* no*/
  color: #ffffff;
}

.pc-confirm-btn {
  background: url("~@/assets/images/recharge/pc/confirm-btn.png") no-repeat;
  width: 248px; /* no*/
  height: 56px; /* no*/
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  color: #ffffff;
  font-family: SourceHanSansCN-Regular;
  font-size: 21px; /* no*/
  border-radius: 4px; /* no*/
  border: none;
} /* no*/

.pc-confirm-btn:hover {
  background: url("~@/assets/images/recharge/pc/confirm-btn-hover.png")
    no-repeat;
  width: 248px; /* no*/
  height: 56px; /* no*/
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  color: #ffffff;
  font-family: SourceHanSansCN-Regular;
  font-size: 21px; /* no*/
  border-radius: 4px; /* no*/
  border: none;
} /* no*/

.pc-main-image {
  background: url("~@/assets/images/recharge/pc/backgourp_main.png") center
    bottom no-repeat;
  opacity: 0.5;
  min-width: 571px; /* no*/
  min-height: 786px; /* no*/
  width: 100%;
  position: fixed;
  bottom: 10px; /* no*/
  display: flex;
  align-content: center;
  justify-content: center;
} /* no*/

.pc-footer {
  text-align: center;
  width: 100%;

  margin-bottom: 38px; /* no*/

} /* no*/

.pc-footer-info {
  width: 100%;
  height: 28px;
  font-size: 12px; /* no*/
  font-weight: normal;
  font-stretch: normal;
  line-height: 19px; /* no*/
  letter-spacing: 0px;
  color: #d2d7e5;
} /* no*/

.pc-footer-info a {
  cursor: pointer;
}

.pc-product-list .card-grid {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: center; */
  max-width: 771px; /* no*/
} /* no*/

.pc-product-list .card-item {
  width: 247px; /* no*/
  height: 196px; /* no*/
  margin: 5px; /* no*/
} /* no*/

.pc-flag {
  float: left;
  margin-top: 8px; /* no*/
  margin-left: -12.5px; /* no*/
  background: url("~@/assets/images/recharge/market/extra.png") center
    bottom no-repeat;
  width: 190px; /* no*/
  height: 50px; /* no*/
}

.pc-flag span {
  line-height: 45px; /* no*/
  color: #ffffff;
  /* font-family: SourceHanSansCN-Regular; */
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  margin-left: -6px; /* no*/
}

.pc-marketing-image {
  min-width: 761px; /* no*/
}

</style>



// WEBPACK FOOTER //
// src/views/recharge/components/index/pc.vue